// @noflow
import PropTypes from 'prop-types';
import * as React from 'react';
import { textAnchor } from '../../../../constants';

const { END } = textAnchor;
const Y_LABEL_X_OFFSET = 10;

export default function AxisYTicks({ barChartData, compHeight, axisStyles, margin, yDomain, yTicksInterval }) {
    const { axisColour, fontColour, fontFamily, fontSize } = axisStyles;
    const lineStyle = { stroke: axisColour };
    const textStyle = {
        fontFamily,
        fontSize,
        stroke: fontColour,
        textAnchor: END
    };

    const offsetHeight = compHeight - margin.bottom - margin.top;
    const yHighestValue = Math.max(...barChartData.map(obj => obj[yDomain]));
    const yRemainder = yHighestValue % yTicksInterval;
    const maxY = yRemainder > 0 ? yHighestValue - yRemainder + yTicksInterval : yHighestValue;
    const yIncr = offsetHeight / maxY;

    const tickAmount = maxY / yTicksInterval;
    const ticks = [];

    const x1 = margin.left - Y_LABEL_X_OFFSET;

    for (let i = 0; i < tickAmount + 1; i++) {
        const y = margin.top + yIncr * (i * yTicksInterval);
        const textValue = maxY - i * yTicksInterval;
        ticks.push(
            <g key={`yTick-${textValue}`} name="yTick">
                <line style={lineStyle} x1={x1} x2={margin.left} y1={y} y2={y} />
                <text style={textStyle} x={x1} y={y}>
                    {textValue}
                </text>
            </g>
        );
    }

    return <g name="yTicks">{ticks}</g>;
}

AxisYTicks.propTypes = {
    axisStyles: PropTypes.shape({
        axisColour: PropTypes.string.isRequired,
        fontColour: PropTypes.string.isRequired,
        fontFamily: PropTypes.string.isRequired,
        fontSize: PropTypes.string.isRequired
    }),
    barChartData: PropTypes.arrayOf(
        PropTypes.shape({
            labelX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            width: PropTypes.number.isRequired,
            x: PropTypes.number.isRequired
        })
    ).isRequired,
    compHeight: PropTypes.number.isRequired,
    margin: PropTypes.shape({
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired,
        bottom: PropTypes.number.isRequired,
        right: PropTypes.number.isRequired
    }),
    yDomain: PropTypes.string.isRequired,
    yTicksInterval: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/graph/axis/axisY/yTicks/index.js